export default "__VITE_ASSET__D0BXlFF9__"